export const PAYMENT_INVALID_ABA_FILE = "The selected ABA file is not valid.";
export const PAYMENT_DUPLICATE_ABA_FILE =
  "ABA file has already been processed.";
export const FORBIDDEN =
  "You have insufficient permission to process the selected ABA file.";
export const GENERIC_ERROR = "Something went wrong. Please try again.";
export const PARTIAL_PROCESS =
  "ABA processing was partially sucessful. Please view history section for reference of the failed transactions.";
export const PROCESS_SUCCESSFUL = "ABA file has been successfuly processed.";
